import React from 'react'
import Modalhandler from 'components/shared/modal/modal-handler'
import PropTypes from 'prop-types'
import InqueryRequestModal from 'components/shared/modals/inquery-request'

const InqueryRequest = ({
  className = 'z-10 fixed bottom-0 left-0 lg:hidden flex items-center justify-center w-full font-normal  btn-primary py-3 cursor-pointer hover:bg-secondary-darkorange',
  children,
  ...props
}) => {
  return (
    <Modalhandler className={className} title="Send request" {...props}>
      {({ toggle }) => <InqueryRequestModal toggle={toggle}>{children}</InqueryRequestModal>}
    </Modalhandler>
  )
}

InqueryRequest.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
}

export default InqueryRequest
